import { Show } from "solid-js";
import { useMatch } from "@solidjs/router";
import SidebarFolders from "./SidebarFolders";
import SidebarSettings from "./SidebarSettings";

const Sidebar = () => {
  const isSettingsPage = useMatch(() => "/customers/:customerId/settings/*");

  return (
    <aside class="flex w-68 flex-none flex-col bg-surface-extra-subtle">
      <div class="flex h-full flex-col">
        <Show when={Boolean(isSettingsPage())} fallback={<SidebarFolders />}>
          <SidebarSettings />
        </Show>
      </div>
    </aside>
  );
};

export default Sidebar;
